import { render, staticRenderFns } from "./settings-option.vue?vue&type=template&id=0de2186a&lang=pug&"
import script from "./settings-option.vue?vue&type=script&lang=js&"
export * from "./settings-option.vue?vue&type=script&lang=js&"
import style0 from "./settings-option.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "settings-option.vue"
export default component.exports